import { useEffect, useState } from "react";
import styles from "./list.module.css";
import dayjs from "dayjs";
import { Snackbar, Alert, Dialog, DialogTitle, IconButton, DialogContent } from "@mui/material";
import { Close } from "@mui/icons-material";
import { Home } from "react-feather";
import axios from "axios";
import Loader from "../../../components/Loader";
import { TableLoader } from "../../../components/ContentLoader";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import AssignPopup from "./add";
import ListView from "./listview";
import MapView from "./mapview";

const BookingList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", date: null });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [formOpen, setFormOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [viewType, setViewType] = useState('list');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    fetchBookings();
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (page === 0) {
      fetchBookings();
    } else {
      setPage(0);
    }
  }, [filterVars]);

  const fetchBookings = () => {
    axios.get(process.env.REACT_APP_API_URL + "v1/assigned-bookings", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      },
      params: {
        page: page + 1, // Laravel uses 1-based index
        per_page: rowsPerPage,
        search: filterVars.searchKey,
        start_date: filterVars.date ? dayjs(filterVars.date[0]).format("YYYY-MM-DD") : null,
        end_date: filterVars.date ? dayjs(filterVars.date[1]).format("YYYY-MM-DD") : null,
      }
    }).then((response) => {
      setContentLoading(false);

      setFilteredData(response.data.data.data); // actual rows
      setTotalCount(response.data.data.total); // total rows
    }).catch(() => {
      setContentLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>View Driver Jobs</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Booking</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>View Driver Jobs</li>
            </ol>
          </nav>
        </div>
        )}

        {contentLoading && <TableLoader />}

        {!contentLoading && <>
          {viewType === 'list' && <ListView filteredData={filteredData} filterVars={filterVars} setSelectedId={setSelectedId.bind(this)} setFormOpen={setFormOpen.bind(this)} setFilterVars={setFilterVars.bind(this)} setViewType={setViewType.bind(this)} page={page} setPage={setPage.bind(this)} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage.bind(this)} totalCount={totalCount} />}
          {viewType === 'map' && <MapView allData={filteredData} setViewType={setViewType.bind(this)} />}
        </>}
      </div>
    </div>

    <Dialog open={formOpen} onClose={(e) => setFormOpen(false)} fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Assign Booking Details To Driver 3</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setFormOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
      <DialogContent>
        <AssignPopup selectedId={selectedId} setLoading={setLoading.bind(this)} modalClose={setFormOpen.bind(this)} setAllData={setFilteredData.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default withAdminAuth(BookingList);